(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 67801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(81637);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(60699);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/atoms/Container/index.tsx
var Container = __webpack_require__(58605);
// EXTERNAL MODULE: ./src/components/molecules/PageHeading/index.tsx
var PageHeading = __webpack_require__(64798);
// EXTERNAL MODULE: ./src/components/molecules/Pagination/index.tsx
var Pagination = __webpack_require__(71742);
;// CONCATENATED MODULE: ./src/utils/BlogPostSlug.ts
const BlogPostType = [
    {
        type: "python",
        text: "Python",
        color: "yellow"
    },
    {
        type: "HTML",
        text: "HTML",
        color: "red"
    },
    {
        type: "conceptos-basicos-de-programacion",
        text: "Conceptos b\xe1sicos",
        color: "blue"
    }
];

// EXTERNAL MODULE: ./src/utils/dateUtils.ts
var dateUtils = __webpack_require__(12819);
// EXTERNAL MODULE: ./src/utils/stringUtils.ts
var stringUtils = __webpack_require__(53618);
// EXTERNAL MODULE: ./src/utils/uploadUtils.ts
var uploadUtils = __webpack_require__(80831);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/atoms/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(1476);
// EXTERNAL MODULE: ./src/components/atoms/Tag/index.tsx
var Tag = __webpack_require__(13476);
;// CONCATENATED MODULE: ./src/components/molecules/Blog/ArticleListItem.tsx










const ArticleListItem = (param)=>{
    let { post  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { attributes  } = post;
    const { image , title , slug , hook  } = attributes;
    const author = {
        ...(ref = attributes.author) === null || ref === void 0 ? void 0 : ref.data.attributes,
        profilePhoto: (ref2 = (ref1 = attributes.author) === null || ref1 === void 0 ? void 0 : ref1.data.attributes.profilePhoto) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.attributes
    };
    const getTextBlogPostSlug = ()=>{
        const type = BlogPostType.find((param)=>{
            let { type  } = param;
            return type === slug;
        }) || {
            text: "Blog",
            color: "gray"
        };
        return type;
    };
    const imgSrc = (image === null || image === void 0 ? void 0 : image.data) ? (0,uploadUtils/* getUploadUrl */.M)(image.data.attributes) : "/defaultBlogPost.png";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "flex flex-col justify-start rounded-xl shadow-md lg:flex-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "basis-1/5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: "w-full rounded-tl-xl rounded-tr-xl object-cover lg:h-56 lg:w-56 lg:rounded-bl-xl lg:rounded-tr-none",
                    src: imgSrc,
                    alt: title,
                    width: 224,
                    height: 224
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex basis-4/5 flex-col p-6 lg:p-0 lg:px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center space-x-2 pt-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                dateTime: attributes.publishedAt,
                                className: "text-xs text-gray-600",
                                children: (0,stringUtils/* capitalize */.kC)((0,dateUtils/* toRelativeDate */.lb)(attributes.publishedAt) || "")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                                type: (ref4 = getTextBlogPostSlug()) === null || ref4 === void 0 ? void 0 : ref4.text,
                                color: (ref5 = getTextBlogPostSlug()) === null || ref5 === void 0 ? void 0 : ref5.color
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mt-3 text-lg font-semibold leading-6 text-primary underline group-hover:opacity-75",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/blog/".concat(slug),
                            children: attributes.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-2 line-clamp-3 h-20 text-sm leading-6 text-gray-600",
                        children: hook
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative mt-2 flex items-center gap-x-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                user: author,
                                size: "lg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-sm leading-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "font-semibold text-gray-900",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "absolute inset-0"
                                            }),
                                            author === null || author === void 0 ? void 0 : author.firstName,
                                            " ",
                                            author === null || author === void 0 ? void 0 : author.lastName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-gray-600",
                                        children: "Equipo Codealo"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Blog_ArticleListItem = (ArticleListItem);

// EXTERNAL MODULE: ./src/contexts/PaginationContext.tsx + 1 modules
var PaginationContext = __webpack_require__(83435);
;// CONCATENATED MODULE: ./src/components/organisms/Blog/ArticleList.tsx




const ArticleList = ()=>{
    const { data  } = (0,PaginationContext/* usePagination */.h)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " space-y-8",
        children: data.map((post)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_ArticleListItem, {
                post: post
            }, post.id))
    });
};
/* harmony default export */ var Blog_ArticleList = (ArticleList);

// EXTERNAL MODULE: ./src/services/DefaultService.ts + 1 modules
var DefaultService = __webpack_require__(82829);
;// CONCATENATED MODULE: ./src/components/views/Blog/Articles.tsx








const Articles = (param)=>{
    let { blogHome , initialData  } = param;
    const { attributes  } = blogHome;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: "mb-16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaginationContext/* PaginationProvider */.b, {
            queryKey: "getBlogPosts",
            queryFunction: DefaultService/* getBlogPosts */.u3,
            initialData: initialData,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
                    title: attributes.title,
                    description: attributes.subTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_ArticleList, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {})
                })
            ]
        })
    });
};
/* harmony default export */ var Blog_Articles = (Articles);

;// CONCATENATED MODULE: ./src/pages/blog/index.tsx



const Index = (param)=>{
    let { blogHome , initialData  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout/* default */.Z, {
        seo: blogHome.attributes.seo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_Articles, {
            blogHome: blogHome,
            initialData: initialData
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var blog = (Index);


/***/ }),

/***/ 12819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lb": function() { return /* binding */ toRelativeDate; }
/* harmony export */ });
/* unused harmony exports HOUR_IN_SECONDS, DAY_IN_SECONDS, dateToSecondsSinceEpoch */
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30120);

const HOUR_IN_SECONDS = 3600;
const DAY_IN_SECONDS = 86400;
// return relative date using luxon in spanish locale
const toRelativeDate = (date)=>{
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(date).setLocale("es").toRelative();
};
const dateToSecondsSinceEpoch = (date)=>{
    return date.getTime() / 1000;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,2552,9842,120,9746,2190,9774,2888,179], function() { return __webpack_exec__(67801); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);